<template>
  <div>
    <img
      v-if="lastMessageIn.snr < 3 && lastMessageIn.snr >= 0"
      src="@/assets/icons/signal/ico/sila-02.svg"
    />
    <img
      v-else-if="lastMessageIn.snr < 0 && lastMessageIn.snr >= -5"
      src="@/assets/icons/signal/ico/sila-03.svg"
    />
    <img
      v-else-if="lastMessageIn.snr < -5 && lastMessageIn.snr >= -10"
      src="@/assets/icons/signal/ico/sila-04.svg"
    />
    <img
      v-else-if="lastMessageIn.snr < -10 && lastMessageIn.snr != null"
      src="@/assets/icons/signal/ico/sila-05.svg"
    />
    <img
      v-else-if="lastMessageIn.snr >= 3 && lastMessageIn.snr != null"
      src="@/assets/icons/signal/ico/sila-01.svg"
    />
    <div v-else class="d-flex align-items-center">
      <img src="@/assets/icons/signal/ico/ico-sila-na.svg" class="mr-2" />
      N/A
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lastMessageIn: Object
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
